import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

import { BehaviorSubject } from 'rxjs';
import { SqliteService } from './sqlite.service'
import { EventsService } from './events.service'


@Injectable({
  providedIn: 'root'
})
export class DatabaseService {
  public insertBatchLimits : any = { 'units' : 30 , 'machines': 50};
  /**
     * bool to check if db ready
     */
  public dbLoaded: boolean = false;
  public migrationsLoaded: boolean = false;
  private migrationsPromise!: Promise<void>;
  private resolveMigrationsPromise!: () => void;
  private rejectMigrationsPromise!: (reason?: any) => void;
  /**
   * hols our database connection
   */
  private db : any;

  private dbName : string ='abaCheck';
  /**
   * In the constructore init the database
   * @param platform 
   * @param _sqlite 
   */
  constructor(
    private platform : Platform,

    private events : EventsService,
    private _sqlite : SqliteService,
  ) { 
    this.migrationsPromise = new Promise<void>((resolve, reject) => {
      this.resolveMigrationsPromise = resolve;
      this.rejectMigrationsPromise = reject;
    });
    // // console.log("🚀 ~ file: database.service.ts:30 ~ DatabaseService ~ SqliteService:", "SqliteService")
    
    this.platform.ready().then(async () => {
      // await this.init();
      //await this.isReady().catch((e) => console.error(`SQL isReady() failure: ${e.message}`));
       this._sqlite.initializePlugin().then(async (ret) => {
         
       });
     });
  }

  async createSqlConnections(){
    try {
      // initialize the connection
      // // console.log("🚀 ~ file: database.service.ts:49 ~ DatabaseService ~ this._sqlite.initializePlugin ~ createConnection:", 'createConnection')
      // // console.log("🚀 ~ file: database.service.ts:50 ~ DatabaseService ~ this._sqlite.initializePlugin ~ this.db:", this.db)
      await this._sqlite.checkConnectionsConsistency();
      let dbName = 'abaCheck';
      
        this.db = await this._sqlite.createConnection(
          dbName,
          false,
          'no-encryption',
          1,
        );
      
      // // console.log("🚀 ~ file: database.service.ts:61 ~ DatabaseService ~ this._sqlite.initializePlugin ~ this.db:", this.db)
      await this.db.open(); //wait un til db open
      
      this.dbLoaded = true; //set as loaded
      await this.createTables();
    }catch( err ){
      alert( JSON.stringify( err ) );
      throw new Error(`createSqlConnections Promise rejection: ${err}`);
      // // console.log("🚀 ~ file: database.service.ts: 66 ~ DatabaseService ~ init ~ err:", err)
    }
  }
  /**
     * set dbloaded to true
     */
  setdbLoaded(){
    this.dbLoaded = true; //set as loaded
  }
  /**
   * so we can check if db is init and created
   * @returns promise with truth when ready
   */
  isReady(){
    let self = this;
    var promise = new Promise(function(resolve, reject){
      var myTimeout = setInterval(() => {
        // // console.log("🚀 ~ file: database.service.ts:98 ~ DatabaseService ~ myTimeout ~ self.dbLoaded:", self.dbLoaded)
        if( self.dbLoaded ){
          clearTimeout(myTimeout);
          resolve( true );
        }else{
        
          // // console.log("🚀 ~ file: database.service.ts:93 ~ DatabaseService ~ isReady ~ isReady:", "Delayed for 0.1 second.")
        }
      }, 100 );
    });

    return promise;
  }

  async migrationsReady(){
    await this.isReady().catch((e) => console.error(`SQL isReady() failure: ${e.message}`));

    if( this.migrationsLoaded ){
      return true;
    }

    await this.migrationsPromise;
    return true;
  }

  async createTables(){
    
    await this.isReady().catch((e) => console.error(`SQL isReady() failure: ${e.message}`));
    // // console.log("🚀 ~ file: sql.service.ts:58 ~ DatabaseService ~ createTables ~ createTables:", "createTables")

    let stringSql : string = `CREATE TABLE IF NOT EXISTS machines (
      id INTEGER PRIMARY KEY, 
      commissioning_state TEXT,
      concession_unit_type TEXT,
      created_at TEXT,
      equipment_location TEXT,
      franchise TEXT,
      latitude TEXT,
      longitude TEXT,
      machine_no TEXT,
      machine_type TEXT,
      machine_type_id INTEGER,
      physical_location TEXT,
      site_number TEXT,
      unit_id INTEGER,
      updated_at TEXT,
      working_state TEXT,
      machine_type_group text,
      programmes text,
      machine_type_description text,
      revisit_required_1 INTEGER,
      visit_before_1 text,
      visit_before_2 text,
      visit_after_1 text,
      last_visit_at text,
      appointment_required text
    )`;

    try{
      let ret: any = await this.db.execute( stringSql );
      // // console.log("🚀 ~ file: database.service.ts:94 ~ DatabaseService ~ createTables ~ machinesSql:", machinesSql)
    }catch( err){
      alert( 'create table error' );
      alert( JSON.stringify( err ) );
      // // console.log("🚀 ~ file: database.service.ts:95 ~ DatabaseService ~ createTables ~ err:", err)
    }

    stringSql = `CREATE TABLE IF NOT EXISTS units (
      id INTEGER PRIMARY KEY, 
      address_1 TEXT,
      address_2 TEXT,
      brand_code TEXT,
      city TEXT,
      company_name TEXT,
      contact_person TEXT,
      country TEXT,
      customer_number TEXT,
      franchise TEXT,
      franchise_id INTEGER,
      locality TEXT,
      name TEXT,
      partner_id INTEGER,
      partner_name TEXT,
      phone_number TEXT,
      postal_code TEXT,
      site_email TEXT,
      site_number TEXT,
      site_reference TEXT,
      updated_at TEXT,
      programmes text,
      store_type text,
      revisit_required_1 INTEGER,
      visit_before_1 text,
      visit_before_2 text,
      visit_after_1 text,
      my_unit INTEGER,
      last_visit_at text,
      wildcard INTEGER,
      appointment_required text
    )`;

    try{
      let ret: any = await this.db.execute( stringSql );
      // // console.log("🚀 ~ file: database.service.ts:94 ~ DatabaseService ~ createTables ~ machinesSql:", machinesSql)
    }catch( err){
      // // console.log("🚀 ~ file: database.service.ts:95 ~ DatabaseService ~ createTables ~ err:", err)
    }

    stringSql = `CREATE TABLE IF NOT EXISTS assessments (
      id INTEGER PRIMARY KEY, 
      actions TEXT,
      complete INTEGER DEFAULT 0,
      complete_at TEXT,
      created_at TEXT,
      data TEXT,
      def TEXT,
      form_id INTEGER,
      gps TEXT,
      machine_id INTEGER,
      machine TEXT,
      programmeId INTEGER,
      scores TEXT,
      synced INTEGER,
      unit TEXT,
      unit_id INTEGER,
      unit_type TEXT,
      actionProps text,
      related_assessment_id text,
      related_data text
    )`;

    try{
      let ret: any = await this.db.execute( stringSql );
      // // console.log("🚀 ~ file: database.service.ts:94 ~ DatabaseService ~ createTables ~ machinesSql:", machinesSql)
    }catch( err){
      // // console.log("🚀 ~ file: database.service.ts:95 ~ DatabaseService ~ createTables ~ err:", err)
    }

    stringSql = `CREATE TABLE IF NOT EXISTS assessment_images (
      id INTEGER PRIMARY KEY, 
      assessment_id INTEGER,
      question_id INTEGER ,
      src TEXT ,
      assessment_complete INTEGER ,
      created_at TEXT,
      programmeId INTEGER,
      form_id INTEGER,
      sync_status TEXT DEFAULT 'pending',
      attempt_count INTEGER DEFAULT 0,
      last_error TEXT,
      last_attempt_at TEXT
    )`

    try{
      let ret: any = await this.db.execute( stringSql );
      // // console.log("🚀 ~ file: database.service.ts:94 ~ DatabaseService ~ createTables ~ machinesSql:", machinesSql)
    }catch( err){
      // // console.log("🚀 ~ file: database.service.ts:95 ~ DatabaseService ~ createTables ~ err:", err)
    }
    

    this.alterTables()
      .then(() => {
        this.migrationsLoaded = true;
        this.resolveMigrationsPromise();
      })
      .catch((err) => {
        console.error('SQL migration failure:', err);
        this.rejectMigrationsPromise(err);
      });
  }//end createtables

  async alterTables(){

    await this.isReady().catch((e) => console.error(`SQL isReady() failure: ${e.message}`));
    let stringSql : string = `ALTER TABLE assessments ADD COLUMN related_assessment_uuid text;`;
    
    try{
      let ret: any = await this.db.execute( stringSql );
      // // console.log("🚀 ~ file: database.service.ts:94 ~ DatabaseService ~ createTables ~ machinesSql:", machinesSql)
    }catch( err){
      //alert( 'create table error' );
      //alert( JSON.stringify( err ) );
      //console.log("🚀 ~ file: database.service.ts:250 ~ DatabaseService ~ createTables ~ err:", err)
    }

    await this.isReady().catch((e) => console.error(`SQL isReady() failure: ${e.message}`));
    stringSql  = `ALTER TABLE assessments ADD COLUMN revisit INTEGER DEFAULT 0;`;
    
    try{
      let ret: any = await this.db.execute( stringSql );
      // // console.log("🚀 ~ file: database.service.ts:94 ~ DatabaseService ~ createTables ~ machinesSql:", machinesSql)
    }catch( err){
      //alert( 'create table error' );
      //alert( JSON.stringify( err ) );
      //console.log("🚀 ~ file: database.service.ts:262 ~ DatabaseService ~ createTables ~ err:", err)
    }

    await this.isReady().catch((e) => console.error(`SQL isReady() failure: ${e.message}`));
    stringSql  = `ALTER TABLE assessments ADD COLUMN revisit_original_data TEXT;`;
    
    try{
      let ret: any = await this.db.execute( stringSql );
    }catch( err){

    }

    let assessmentImageColumns = [
      `ALTER TABLE assessment_images ADD COLUMN sync_status TEXT DEFAULT 'pending';`,
      `ALTER TABLE assessment_images ADD COLUMN attempt_count INTEGER DEFAULT 0;`,
      `ALTER TABLE assessment_images ADD COLUMN last_error TEXT;`,
      `ALTER TABLE assessment_images ADD COLUMN last_attempt_at TEXT;`,
    ];

    for ( const sql of assessmentImageColumns ) {
      await this.isReady().catch((e) => console.error(`SQL isReady() failure: ${e.message}`));
      try{
        let ret: any = await this.db.execute( sql );
      }catch( err){

      }
    }
  }

  async insertUnits( data: any , doneCount : number  ){ //{ units: [] , delete : []  }
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    // console.log("SqlService -> insertUnits -> 'Start units", 'Start units');
    this.insertBatchLimits.units = 30 ; //sqlite max is 999 params, so set this not to exceed that when mulktiplied by param cntt 
    let queries = [];
    let myClass = this;
     let sqlStart = `INSERT OR REPLACE INTO units (
      id ,
      address_1 , 
      address_2 , 
      brand_code ,
      city , 
      company_name , 
      contact_person , 
      country , 
      customer_number , 
      franchise, 
      franchise_id , 
      locality , 
      name , 
      partner_id , 
      partner_name , 
      phone_number , 
      postal_code , 
      site_email , 
      site_number ,   
      site_reference , 
      updated_at ,
      programmes,
      store_type,
      revisit_required_1,
      visit_before_1,
      visit_after_1,
      my_unit,
      last_visit_at,

      wildcard,

      appointment_required 

    )
    VALUES ( ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ? )`; 
    //if you add new field then need to amend in 4 places
    let sql = sqlStart;
    let params = [];
    let units = [];
    units = data.units ? data.units : [];
    // console.log("🚀 ~ file: database.service.ts:338 ~ units:", units)

    for ( const [ i , row ]   of units.entries() ){
      params.push( ...[
        row.id ,
        row.address_1 , 
        row.address_2 , 
        row.brand_code ,
        row.city , 
        row.company_name , 
        row.contact_person , 
        row.country , 
        row.customer_number , 
        row.franchise, 
        //10
        row.franchise_id , 
        row.locality , 
        row.name , 
        row.partner_id , 
        row.partner_name , 
        row.phone_number , 
        row.postal_code , 
        row.site_email , 
        row.site_number ,   
        row.site_reference , 
        //20
        row.updated_at, 
        row.programmes ,
        row.store_type ,
        row.revisit_required_1,
        row.visit_before_1,
        row.visit_after_1,
        row.my_unit,
        row.last_visit_at,
        row.wildcard,
        row.appointment_required
        //30
      ] );
      
      if(  i  % this.insertBatchLimits.units === 0 || i == ( units.length - 1 ) ){
        queries.push( { sql: sql, params: params, count : i } );
        sql = sqlStart;
        params = [];
      }else{
        sql += ', ( ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ? )';
        // console.log("SqlService -> insertMachinesBatch -> sql", sql)

      }
    }
    //add the last one in
    //queries.push( { sql: sql, params: params } );

    if( data.delete && data.delete.length > 0  ){
      console.log("SqlService -> insertUnits -> data.delete", data.delete)
      //append sql statement to run that will delete all in this list
      let sqlStart = "DELETE FROM units WHERE id = ? ";
      let sql = sqlStart ;
      let params = [];
      let batchItems = 90; //batch into items as has max number of params
      for ( const [ i , v ]  of data.delete.entries()  ) {
        
        params.push( v );

        if(  i  % batchItems === 0 || i == ( data.delete.length - 1 ) ){
          queries.push( { sql: sql, params: params , count : units.length - 1   } );
          sql = sqlStart;
          params = [];
        }else{
          sql += " OR id = ?  " ;
        }

      }
      //let count = machines.length ;
      //console.log("SqlService -> insertMachines -> queries", queries)

    }


    // //console.log("🚀 ~ file: database.service.ts:373 ~ doneCount:", doneCount)
    //now process queries
    const promises = queries.map( async ( q ) => {
     // // console.log("🚀 ~ file: database.service.ts:363 ~  q:",  q)

        
      	await this.db.query( q.sql , q.params );
        myClass.events.publish('syncProgress',
          { msg : 'unitProgress', count : (q.count + 1)  }
        );
      	
    	});
  
   
    await Promise.all( promises );

    this._sqlite.saveToStore( this.dbName );

   }

   async insertMachines( data: any, doneCount : number  ){
    // //console.log("🚀 ~ file: database.service.ts:390 ~ data:", data)
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    // console.log("SqlService -> insertUnits -> 'Start machines", 'Start machines');
    this.insertBatchLimits.units = 30 ; //needs to be less than 999 params
    let queries = [];
    let myClass = this;
     let sqlStart = `INSERT OR REPLACE INTO machines (
      id ,
      commissioning_state ,
      concession_unit_type ,
      created_at ,
      equipment_location ,
      franchise ,
      latitude ,
      longitude ,
      machine_no ,
      machine_type ,
      machine_type_group ,
      machine_type_id ,
      physical_location ,
      site_number ,
      unit_id ,
      updated_at ,
      working_state   ,
      programmes,
      machine_type_description,

      revisit_required_1,
      visit_before_1,
      visit_before_2,
      visit_after_1,
      last_visit_at,


      appointment_required
    )
    VALUES ( ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ? ) `;
    let sql = sqlStart;
    let params = [];
    let machines = [];
    machines = data.machines ? data.machines : [] ;
    // console.log("🚀 ~ file: database.service.ts:478 ~ machines:", machines)
    
    for ( const [ i , row ]   of machines.entries() ){
      params.push( ...[
        row.id ,
        row.commissioning_state ,
        row.concession_unit_type ,
        row.created_at ,
        row.equipment_location ,
        row.franchise ,
        row.latitude ,
        row.longitude ,
        row.machine_no ,
        row.machine_type ,
        //10
        row.machine_type_group ,
        row.machine_type_id ,
        row.physical_location ,
        row.site_number ,
        row.unit_id ,
        row.updated_at ,
        row.working_state,
        row.programmes,
        row.machine_type_description,
        row.revisit_required_1,
        //10
        row.visit_before_1,
        row.visit_before_2,
        row.visit_after_1,
        row.last_visit_at,
        row.appointment_required
        //25
      ] );
      
      if(  i  % this.insertBatchLimits.units === 0 || i == ( machines.length - 1 ) ){
        queries.push( { sql: sql, params: params , count : i  } );
        sql = sqlStart;
        params = [];
      }else{
        sql += ', ( ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ? )';
        // console.log("SqlService -> insertMachinesBatch -> sql", sql)
      }
    }
    //add the last one in
    //queries.push( { sql: sql, params: params } );
 
    // console.log("SqlService -> insertMachinesBatch -> data.delete", data.delete);

    if( data.delete && data.delete.length > 0 ){
      //append sql statement to run that will delete all in this list
      let sqlStart = "DELETE FROM machines WHERE ID IN (";
      let sql = sqlStart ;
      let params = [];
      let batchItems = 90;
      for ( const [ i , v ]  of data.delete.entries()  ) {
        
        params.push( v );

        if(  i  % batchItems === 0 || i == ( data.delete.length - 1 ) ){
          sql += " ? )"; //add end bracket
          queries.push( { sql: sql, params: params , count : machines.length - 1 } );
          sql = sqlStart;
          params = [];
        }else{
          sql += " ?,  " ;
        }

      }
      //let count = machines.length ;
     // console.log("SqlService -> insertMachines -> queries", queries)


      

    }
    // console.log("SqlService -> insertMachinesBatch -> queries", queries);

    let totalCount =  doneCount;
    let queryCount = 0;
    //now process queries
    const promises = queries.map( async ( q ) =>{
      doneCount += q.count + 1;
      queryCount = q.count + 1;
      myClass.events.publish('syncProgress',
        { msg : 'machineProgress', count : ( queryCount )  }
      );
      await await this.db.query( q.sql , q.params );
      
      
    });
    

    await Promise.all( promises );

    
    this._sqlite.saveToStore( this.dbName );

    return totalCount + queryCount;

    
   }


  /**
     * list of all tables that are in the database
     * @returns array
     */
  async describeTables(  ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let self = this;
    let query = "SELECT name FROM sqlite_schema WHERE type='table' ORDER BY name" ;
    let ret: any = await this.db.query( query );
    return ret;
  }

  /**
   * gets all the columns from a given table
   * @param table 
   * @returns array
   */
  async getColumnNames( table : string  ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let self = this;
    let query = "PRAGMA table_info('"+table+"') ";
    let ret: any = await this.db.query( query );
    return ret.values;
  }

  /**
   * returns all rows of data from a given table
   * @param table 
   * @returns array
   */
  async selectAllFrom( table : string  ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let self = this;
    let query = "SELECT * FROM " + table ;
    let ret: any = await this.db.query( query );
    return ret.values;
  }//end select * from fn


  async getCompleteAssessments(  ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let self = this;
    let query = "SELECT * FROM assessments WHERE complete = ?  ";
    // // console.log("🚀 ~ file: database.service.ts:127 ~ DatabaseService ~ selectAllFrom ~ query:", query)
    let ret: any = await this.db.query( query , [ 1 ] );
    return ret.values;
  }

  async getMaxUpdatedAt( table : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let self = this;

    let query2 = "SELECT COUNT(*),   MIN( updated_at ), MAX( updated_at ) as max_ts FROM " + table+" GROUP BY updated_at " ;
    let ret2: any = await this.db.query( query2 );
    // // console.log("🚀 ~ file: database.service.ts:265 ~ DatabaseService ~ getMaxUpdatedAt ~ ret.values:", ret2.values)


    let query = "SELECT COUNT(*),   MIN( updated_at ), MAX( updated_at ) as max_ts FROM " + table ;
    let ret: any = await this.db.query( query );
    // // console.log("🚀 ~ file: database.service.ts:265 ~ DatabaseService ~ getMaxUpdatedAt ~ ret.values:", ret.values)

    return ret.values[0].max_ts;
   }


   async getAssessmentsForPogramme( programme_id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));

    let query = 'SELECT * FROM assessments WHERE programmeId = ? '
    // // console.log("🚀 ~ file: database.service.ts:567 ~ DatabaseService ~ getAssessmentsForPogramme ~ query:", query)
    let data: any = await this.db.query( query, [ programme_id ] );
      
    let result = [];
    for (var i = 0; i < data.values.length; i++) {
      result.push( data.values[i] )
    }
    return  result ;

  }

  async countAssessmentByProgramme(  ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let myClass = this;
    let sql = "SELECT COUNT(*) as cnt,  programmeId FROM assessments WHERE complete=0 GROUP BY programmeId"  ;
    let data: any = await this.db.query( sql  );
    return data.values;
  }


  /**
   * Selects units
   * @param programmeId 
   * @param sortOrder 
   * @param limit 
   * @param offset 
   * @param searchTerm 
   * @param myUnit 
   * @returns 
   */
  async selectUnits( 
    programmeId : string, 
    sortOrder : any, 
    limit: Number, 
    offset: Number  ,
    searchTerm : String, 
    myUnit : Number
  ){



    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let myClass = this;
    let params : any = [];
    let sql = "SELECT * FROM units WHERE 1 "  ;
    if( programmeId ){
      //finds only ones for this programme
      sql += " AND (";
      sql += " units.programmes = ? ";
      sql += " OR units.programmes LIKE ? ";
      sql += " OR units.programmes LIKE ? ";
      sql += " OR units.programmes LIKE ? ";
      sql += " ) ";

      params.push( programmeId );
      params.push( '%|' + programmeId +'|%' );
      params.push( programmeId +'|%' );
      params.push( '%|' + programmeId  );
    }

    if( myUnit ){
      sql += ' AND my_unit = 1 ';
    }

    if( searchTerm.length  > 0 ){

      let searchFields = [
        'units.name', 
        'units.address_1' ,
        'units.address_2' ,
        'units.city' ,
        'units.postal_code' ,
        'units.locality' ,
        'units.country' ,
        'units.site_email' ,
        'units.site_reference' ,
      ];


      sql += "AND ( ''  ";    
      for (var i = 0; i < searchFields.length; i++) {
        sql += " || COALESCE('-' || " + searchFields[ i ] + " , '') " ;
      }
      sql += ") LIKE ?";

      params.push( '%' + searchTerm +'%' );
      

    }

    //add a sort order
    for ( const [ i , row ]   of sortOrder.entries() ){
      if( i == 0 ){
        sql += ' ORDER BY '
      }else{
        sql += ', '
      }
      sql +=  row.field + '  ' + row.order;

    }

    if( limit  ){
      sql += ' LIMIT '+ limit + ' OFFSET ' + offset; //add limit and offset
    }

    // // console.log("🚀 ~ file: sql.service.ts ~ line 571 ~ SqlService ~ myClass.dbInstance.executeSql ~ sql", sql)


    let data: any = await this.db.query( sql , params );
    return data.values;
   

  }

  /**
   * GETS machines with unit values needed
   */
  async selectMachinesWithUnits( 
    programmeId : string, 
    idList : Number[ ] , 
    sortBy : String[], 
    limit: Number, 
    offset: Number  ,
    searchTerm : String,
    myUnit : Number
  ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    // console.log("SqlService -> selectMachinesWithUnits -> programmeId", programmeId)
    // console.log("SqlService -> selectMachinesWithUnits -> idList", idList)
    let params : any = [];
    //filter non numeric from id list
    idList = idList.filter( ( v )=>{
      return typeof( v ) === 'number';
    });


    let fields = [
        'units.address_1 as unit_address_1',
        'units.address_2 as unit_address_2',
        'units.brand_code as unit_brand_code',
        'units.city as unit_city',
        'units.company_name as unit_company_name',
        'units.contact_person as unit_contact_person',
        'units.country as unit_country',
        'units.customer_number as unit_customer_number',
        'units.franchise as unit_franchise',
        'units.franchise_id as unit_franchise_id',
        'units.locality as unit_locality',
        'units.name as unit_name',
        'units.partner_id as unit_partner_id',
        'units.partner_name as unit_partner_name',
        'units.phone_number as unit_phone_number',
        'units.postal_code as unit_postal_code',
        'units.site_email as unit_site_email',
        'units.site_number as unit_site_number',
        'units.site_reference as unit_site_reference',
        'units.updated_at as unit_updated_at',
        'units.my_unit as unit_my_unit',

        'units.contact_person as unit_contact_person',
        'units.phone_number as unit_phone_number',
        'units.site_email as unit_site_email',

        'machines.physical_location' ,
      ];

      
    let myClass = this;
    let sql = "SELECT machines.* ";
    //add unit fields
    for (var i = 0; i < fields.length; i++) {
      sql += ", " + fields[ i ];
    }

    sql+= " FROM machines, units WHERE machines.unit_id = units.id "  ;


    if( programmeId  ){
      //finds only ones for this programme
      sql += " AND (";
      sql += " machines.programmes = ? ";
      sql += " OR machines.programmes LIKE ? ";
      sql += " OR machines.programmes LIKE ? ";
      sql += " OR machines.programmes LIKE ? ";
      sql += " ) ";

      if( myUnit ){
        sql += ' AND my_unit = 1 ';
      }

      params.push( programmeId );
      params.push( '%|' + programmeId +'|%' );
      params.push( programmeId +'|%' );
      params.push( '%|' + programmeId  );
    }

    //string search
    // // console.log("🚀 ~ file: sql.service.ts ~ line 705 ~ SqlService ~ searchTerm", searchTerm);
    if( searchTerm.length  > 0 ){

      let searchFields = [
        'units.name', 
        'units.address_1' ,
        'units.address_2' ,
        'units.city' ,
        'units.postal_code' ,
        'units.locality' ,
        'units.country' ,
        'units.site_email' ,
        'units.site_reference' ,

        'units.contact_person',
        'units.phone_number',
        'units.site_email',

        'machines.machine_no' ,
        'machines.machine_type' ,
        'machines.machine_type_group' ,
        'machines.machine_type_description' ,
        'machines.physical_location' ,
      ];


      sql += "AND ( ''  ";    
      for (var i = 0; i < searchFields.length; i++) {
        sql += " || COALESCE('-' || " + searchFields[ i ] + " , '') " ;
      }
      sql += ") LIKE ?";

      params.push( '%' + searchTerm +'%' );
      

    }
    if( idList.length > 0 ){
      //we have passed a list of ids, so we need see if in this list
      sql += " AND machines.id IN ( " ;
      //sql += idList.join(', ');
      for ( const [ i , v ]  of idList.entries()  ) {
        sql += i > 0 ? ', ': '';
        sql += " ? " ;
        params.push( v );
      }
      sql +=  ") ";

      //maintain order
      sql += ' ORDER BY CASE machines.id ';
      for ( const [ i , v ]  of idList.entries()  ) {
        sql += ' WHEN "'+v+'" THEN '+ String(i).padStart(4, '0')+' ';
      }
      sql += ' END  ';
      

      
    }
    if( limit  ){
      sql += ' LIMIT '+ limit + ' OFFSET ' + offset; //add limit and offset
    }
    



    


    
    let data: any = await this.db.query( sql , params );
     
    let result = [];
    result = data.values;
    /*for (var i = 0; i < data.values.length; i++) {
      result.push( data.values.item(i) )
    }*/
    return  result ;
  }//end fn selectMachinesWithUnits
  async insertAssessment( data: any ){
    console.log("🚀 ~ file: database.service.ts:925 ~ data:", data)
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    if( ! data.complete ){
      data.complete = 0;
    }
    //if data.revisit is not set default o zero
    if( ! data.revisit ){
      data.revisit = 0;
    }
    if( ! data.revisitOriginalData ){ //if revisitOriginalData is not set, default to empty object
      data.revisitOriginalData = {}; //set to empty object
    }

    let myClass = this;
     let sql = `INSERT OR REPLACE INTO assessments (
      id ,
      complete, 
      created_at ,
      data ,
      form_id ,
      machine_id ,
      machine ,
      programmeId ,
      unit ,
      unit_id ,
      unit_type,
      revisit,
      revisit_original_data
    )
    VALUES ( ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ? ) `;
     // // console.log("🚀 ~ file: database.service.ts:866 ~ DatabaseService ~ insertAssessment ~ sql:", sql)
    
    if( typeof data.machine_id == 'undefined' ){
      data.machine_id = '';
    }
    let params = [
      data.id,
      data.complete,
      data.created_at,
      this.jsonStringify( data.data ),
      data.form_id ,
      data.machine_id ,
      this.jsonStringify( data.machine ),
      data.programmeId ,
      this.jsonStringify( data.unit ),
      data.unit_id ,
      data.unitType,
      data.revisit,
      this.jsonStringify( data.revisitOriginalData ),

    ];
    // // console.log("🚀 ~ file: database.service.ts:882 ~ DatabaseService ~ insertAssessment ~ params:", params)
    
    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );

   }

   async updateAssessment( data: any ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    //alert( 'run update');
    if( ! data.complete ){
      data.complete = 0;
    }
    if( ! data.complete_at ){
      data.complete_at = '';
    }
    if( ! data.def ){
      data.def = '';
    }
    if( ! data.gps ){
      data.gps = '';
    }
    if( ! data.scores ){
      data.scores = '';
    }
    if( ! data.actions ){
      data.actions = '';
    }
    if( ! data.actionProps ){
      data.actionProps = '';
    }

    let myClass = this;
     let sql = `UPDATE assessments SET 
      actions = ? ,
      actionProps = ? ,
      complete = ?,
      complete_at = ?, 
      data  = ? ,
      def  = ? ,
      gps  = ? ,
      scores  = ? 
    
    WHERE id = ? `;

    let params = [
      
      this.jsonStringify( data.actions ),
      this.jsonStringify( data.actionProps ),
      data.complete,
      data.complete_at,
      this.jsonStringify( data.data ),
      this.jsonStringify( data.def ),
      this.jsonStringify( data.gps ),
      this.jsonStringify( data.scores ),
      data.id,
    ];
    
    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );
   }

   async getAssessmentById( id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));

    let myClass = this;

    let sql = 'SELECT * FROM assessments WHERE id = ? '

    let data: any = await this.db.query( sql, [ id ] );
    // // console.log("🚀 ~ file: database.service.ts:926 ~ DatabaseService ~ getAssessmentById ~ data:", data)
    let result = [];
    if( data.values.length > 0 ){
      for (var i = 0; i < data.values.length; i++) {
        result.push( data.values[i] )
      }
      return data.values[0] ;
    }else{
      return {} ;
    }


  
  }


  async updateAssessmentUnit( id : string, unit : any, machine : any ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    // console.log("SqlService -> updateAssessmentUnit -> machine", machine)
    // console.log("SqlService -> updateAssessmentUnit -> unit", unit)
    let myClass = this;

    let sql = 'UPDATE assessments SET unit = ?, unit_id = ?, machine = ?, machine_id = ? WHERE id = ? '
    let machine_id ='';
    if(   typeof machine.id != 'undefined'){
      machine_id = machine.id;
    }
    let params = [
      this.jsonStringify( unit ),
      unit.id,
      this.jsonStringify( machine ),
      machine_id,
      id
    ];
  

    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );
  }

  async deleteAssessment( id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let myClass = this;

    let sql = 'DELETE FROM assessments WHERE id = ? '
    // console.log("SqlService -> deleteAssessment -> sql", sql + id )
    let params = [
      id
    ];
    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );
  }

  /* --------------------------------------------------------------------------------------------
                           IMAGES
  ------------------------------------------------------------------------------------------------*/

  async addImage( id : string , assessment_id : string , question_id : string , src : string , created_at : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let myClass = this;
    let assessmentMeta = await this.getAssessmentImageMeta( assessment_id );
    let sql = `INSERT OR REPLACE INTO assessment_images (
      id,
      assessment_id,
      question_id,
      src, 
      created_at,
      programmeId,
      form_id,
      sync_status,
      attempt_count

      )
      VALUES ( ?, ?, ?, ?, ?, ?, ?, ?, ? ) `;

    let params = [
      id,
      assessment_id,
      question_id , 
      src,
      created_at,
      assessmentMeta.programmeId,
      assessmentMeta.form_id,
      'pending',
      0
    ];
   
    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );
  }

  async deleteImage( id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let sql = 'DELETE FROM assessment_images WHERE id = ? '
    // console.log("SqlService -> deleteAssessment -> sql", sql + id )
    let params = [ id ];
    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );
  }

  async addImageArray( id : string , assessment_id : string , question_id : string , images : string[] , created_at : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let self = this;
    let assessmentMeta = await this.getAssessmentImageMeta( assessment_id );

    let sql = `INSERT OR REPLACE INTO assessment_images (
      id,
      assessment_id,
      question_id,
      src, 
      created_at,
      programmeId,
      form_id,
      sync_status,
      attempt_count

      )
      VALUES ( ?, ?, ?, ?, ?, ?, ?, ?, ? ) `;

      let params :any[] = [];
      images.forEach( (src : any , index : number  ) => {
        if( index > 0 ){
          sql+= `,  ( ?, ?, ?, ?, ?, ?, ?, ?, ? ) `;
        }

        params.push( 9+id+index );//unique id
        params.push( assessment_id );
        params.push( question_id );
        params.push( src );
        params.push( created_at );
        params.push( assessmentMeta.programmeId );
        params.push( assessmentMeta.form_id );
        params.push( 'pending' );
        params.push( 0 );

      });
      let ret: any = await this.db.query( sql , params );
      await this._sqlite.saveToStore( this.dbName );
  
  }

  async getAssessmentImageMeta( assessment_id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let ret: any = await this.db.query( 'SELECT programmeId, form_id FROM assessments WHERE id = ? ', [ assessment_id ] );
    if( ret.values.length ){
      return {
        programmeId: ret.values[0].programmeId || null,
        form_id: ret.values[0].form_id || null
      };
    }
    return {
      programmeId: null,
      form_id: null
    };
  }

  async getCompletedImages( limit : number | null = null, offset : number = 0 ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));


    let sql = `SELECT 
      assessment_images.id, 
      assessment_images.question_id , 
      assessment_images.assessment_id , 
      assessment_images.created_at ,
      assessment_images.sync_status,
      assessment_images.attempt_count,
      assessment_images.last_error,
      assessment_images.last_attempt_at,

      assessments.form_id,
      assessments.programmeId as programme_id
      
      FROM assessment_images, assessments 
      
      WHERE 
      assessment_images.assessment_id = assessments.id 
      AND assessments.complete = ? `;
      sql += ` ORDER BY assessment_images.id `;
      let params : any[] = [ 1 ];
      if( limit ){
        sql += ` LIMIT ? OFFSET ? `;
        params.push( limit );
        params.push( offset );
      }
      let data: any = await this.db.query( sql , params );
   
      let result = [];
      for (var i = 0; i < data.values.length; i++) {
        result.push( data.values[i] )
      }
      return  result ;
  }

  async getOrphanedImages( limit : number | null = null, offset : number = 0 ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));

    let sql = `SELECT 
      assessment_images.id, 
      assessment_images.question_id , 
      assessment_images.assessment_id , 
      assessment_images.created_at ,
      assessment_images.sync_status,
      assessment_images.attempt_count,
      assessment_images.last_error,
      assessment_images.last_attempt_at,
      assessment_images.form_id,
      assessment_images.programmeId as programme_id
      
      FROM assessment_images
      LEFT JOIN assessments ON assessment_images.assessment_id = assessments.id
      
      WHERE assessments.id IS NULL `;
      sql += ` ORDER BY assessment_images.id `;

      let params : any[] = [];
      if( limit ){
        sql += ` LIMIT ? OFFSET ? `;
        params.push( limit );
        params.push( offset );
      }
      let data: any = await this.db.query( sql , params );
   
      let result = [];
      for (var i = 0; i < data.values.length; i++) {
        result.push( data.values[i] )
      }
      return  result ;
  }

  async deleteOrphanedImagesBeforeAssessmentId( assessment_id : number ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));

    let sql = `DELETE FROM assessment_images
      WHERE assessment_id < ?
      AND NOT EXISTS (
        SELECT 1
        FROM assessments
        WHERE assessments.id = assessment_images.assessment_id
      ) `;

    let ret: any = await this.db.query( sql , [ assessment_id ] );
    await this._sqlite.saveToStore( this.dbName );
    return ret;
  }

  async getImageById( id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));

    let sql = `SELECT
      id,
      assessment_id,
      question_id,
      src,
      created_at,
      programmeId as programme_id,
      form_id,
      sync_status,
      attempt_count,
      last_error,
      last_attempt_at
      FROM assessment_images
      WHERE id = ? `;

    let data: any = await this.db.query( sql , [ id ] );
    if( data.values.length ){
      return data.values[0];
    }
    return null;
  }

  async getCompletedAssessmentIdsWithImages( ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));

    let sql = `SELECT DISTINCT
      assessment_images.assessment_id
      
      FROM assessment_images, assessments 
      
      WHERE 
      assessment_images.assessment_id = assessments.id 
      AND assessments.complete = ? `;

    let data: any = await this.db.query( sql , [ 1 ] );
    let result = [];
    for (var i = 0; i < data.values.length; i++) {
      result.push( data.values[i].assessment_id )
    }
    return  result ;
  }

  async markImageSyncFailed( id : string, error : any ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));

    let errorText = '';
    try{
      errorText = typeof error == 'string' ? error : JSON.stringify( error );
    }catch( e ){
      errorText = 'Image sync failed';
    }

    let sql = `UPDATE assessment_images SET
      sync_status = ?,
      attempt_count = COALESCE(attempt_count, 0) + 1,
      last_error = ?,
      last_attempt_at = ?
      WHERE id = ? `;

    let params = [
      'failed',
      errorText.substring(0, 1000),
      new Date().toISOString(),
      id
    ];

    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );
  }

  async getAssessmentImagesCounts( id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let sql = 'SELECT id, question_id , created_at FROM assessment_images WHERE assessment_id = ? '
    let ret: any = await this.db.query( sql , [ id ] );
    return ret.values;
  }

  async getQuestionImages( assessment_id : string, question_id :string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let sql = 'SELECT id, question_id , src, created_at FROM assessment_images WHERE assessment_id = ? AND question_id = ? ';
    let ret: any = await this.db.query( sql , [ assessment_id , question_id  ]  );
    return ret.values;
  }


  async deleteAllAssessmentImages( assessment_id : string ){
    await this.migrationsReady().catch((e) => console.error(`SQL migrationsReady() failure: ${e.message}`));
    let myClass = this;

    let sql = 'DELETE FROM assessment_images WHERE assessment_id = ? '
    // console.log("SqlService -> deleteAssessment -> sql", sql + id )
    let params = [
      assessment_id
    ];
    let ret: any = await this.db.query( sql , params );
    await this._sqlite.saveToStore( this.dbName );
  }

  jsonStringify( obj : any ){
    if(typeof obj == "object")
        return JSON.stringify(obj);
    else{
        //alert("found already stringified object")
        return obj;
    }
  }

}
